import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import styled, { css } from 'styled-components';
export const CommonRadioListContainerStyles = css `
  display: flex;
  flex-wrap: wrap;
  gap: ${fluid(12, 16)} ${fluid(24, 48)};

  flex-direction: column;

  @media ${from(Device.Tablet)} {
    flex-direction: row;
  }

  &[data-layout='vertical'] {
    flex-direction: column;
  }
`;
const Container = styled.div `
  ${CommonRadioListContainerStyles};
`;
const Option = styled.label `
  display: flex;
  white-space: nowrap;
`;
const Input = styled.input `
  /* Ensure iOS doesn't apply default border radius */
  -webkit-appearance: none !important;

  ${srOnly};
`;
export const CommonRadioListLabelStyles = css `
  ${fonts.aptos.regular};

  --bgColour: ${brand.global.white};
  --borderColour: ${brand.global.black};
  --borderRadius: 50%;
  --textColour: ${brand.global.black};

  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-size: ${fluid(16, 18)};
  line-height: 1em;
  color: var(--textColour);

  &::before {
    ${transition('background-color, border-color', 0.2)};

    content: '';
    display: inline-block;
    background: transparent;
    background-clip: content-box;
    border: 1px solid var(--borderColour);
    border-radius: var(--borderRadius);
    box-sizing: border-box;
    background-color: var(--bgColour);
    height: 17px;
    margin-right: ${fluid(8, 12)};
    padding: 3px;
    width: 17px;
  }

  ${Input}:disabled + & {
    pointer-events: none;
    opacity: 0.5;
  }

  ${Input}:checked + &::before {
    background-color: var(--textColour);
  }
`;
const Label = styled.label `
  ${CommonRadioListLabelStyles};
`;
const RadioListStyles = {
    Container,
    Input,
    Label,
    Option,
};
export default RadioListStyles;
